module.exports = __webpack_public_path__ + "static/media/horse-saddle.2c87dadc.svg";